// extracted by mini-css-extract-plugin
module.exports = {"tk_blob":"blobz_tk_blob__7LSMu","blob-turn":"blobz_blob-turn__rBYuE","blob-skew":"blobz_blob-skew__OoPY5","blob-scale":"blobz_blob-scale__zM1eG"};